import React, {Component} from "react";
import {Dropdown} from "react-bootstrap";
import StompClient from "react-stomp-client";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";
import {notificationActions} from "../../../../../actions/notification.actions";
import * as moment from "moment";
import {Link} from "react-router-dom";
import NotificationCategory from "./NotificationCategory";
import {pathHelper} from "../../../../../helpers/path-helper";

class Notification extends Component {

    state = {
        openNotification: null
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(notificationActions.getUnRead());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { dispatch, getUnReadList } = this.props;
        if(prevState.openNotification === true && this.state.openNotification === false) {
            const ids = getUnReadList.map((item) => {return item.id});
            if(ids) {
                dispatch(notificationActions.readByArrayIds(ids));
            }
        }
    }

    handleMessage = (stompMessage) => {
        console.log(stompMessage);
        const { dispatch } = this.props;
        dispatch(notificationActions.getUnRead());
    };

    handleToggleNotification = (toggle) => {
        console.log(toggle);
        this.setState({
            openNotification: toggle
        });
    }

    render() {
        const {t, getUnReadList } = this.props;
        return (
            <React.Fragment>
                <StompClient
                    endpoint={`ws://${pathHelper.getUrlHostname()}:15674/ws`}
                    topic={"exchange/notification/"}
                    onMessage={this.handleMessage}
                >
                    <Dropdown id="dropdown-notification" className="nav-link" onToggle={(toggle) => this.handleToggleNotification(toggle)}>
                        <Dropdown.Toggle variant="" className={`hl_animated ${getUnReadList?.length > 0 ? "bounce" : ""}`}>
                            <i className="far fa-bell"/>
                            { getUnReadList?.length > 0 ? (
                                <span className="badge badge-danger navbar-badge">{getUnReadList.length}</span>
                            ) : (<React.Fragment/>) }
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-menu-lg">
                            <Dropdown.Header>{getUnReadList?.length} {t('notifications')}</Dropdown.Header>
                            <Dropdown.Divider/>
                            { getUnReadList?.map((notification, idx) => {
                                return (
                                    <Dropdown.Item key={idx}>
                                        <NotificationCategory category={notification.category} />
                                        <span className="text-sm">{ t(notification.text) } &nbsp; { notification.networkDeviceId ? ("#" + notification.networkDeviceId ) : ("") }</span>
                                        <span className="float-right text-muted text-sm">{ moment(notification.createDate).fromNow() }</span>
                                    </Dropdown.Item>
                                )
                            }) }
                            <Dropdown.Item className="dropdown-footer">
                                <Link to={"/panel/notifications"} className="text-decoration-none">
                                    { t('show-all-notification') }
                                </Link>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </StompClient>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    const { getList, getUnReadList } = state.notificationReducer;
    return {
        getList,
        getUnReadList
    }
}
export default withNamespaces()(connect(mapStateToProps)(Notification));
